'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (config) {
  return function (value) {
    if (value === '') {
      return null;
    }

    var stringBlacklist = config.blacklist.map(function (w) {
      return String(w);
    });
    return stringBlacklist.includes(value) ? config.message : null;
  };
};